export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-100px.jpg.b14f5505.webp";